import { realEstateAgentLoanOfficersHooks } from 'reducers/slices/realEstateAgent/loanOfficersSlice';
import { pathOr } from 'ramda';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficers = () => {
  const { loanOfficers, loadLoanOfficers, loadMoreLoanOfficers } = realEstateAgentLoanOfficersHooks.use();

  const totalCount = pathOr(null, ['meta', 'totalCount'], loanOfficers);

  return {
    isLoanOfficersLoading: useFetchStatus(loanOfficers.loadingStatus).isPending,
    isLoanOfficersIdle: useFetchStatus(loanOfficers.loadingStatus).isIdle,
    loanOfficers: loanOfficers.items,
    meta: loanOfficers.meta,
    isLoanOfficersLoadingMore: useFetchStatus(loanOfficers.moreLoadingStatus).isPending,
    loadLoanOfficers,
    loadMoreLoanOfficers,
    totalCount,
  };
};

export default useLoanOfficers;



// WEBPACK FOOTER //
// ./src/reducers/hooks/realEstateAgent/useLoanOfficers.js